/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  dialogAcceptTitle: {
    id: "b2b.zadosti-odbaveni-grid.dialogAccept.title",
    defaultMessage: "Confirmation of request"
  },
  dialogDeclineTitle: {
    id: "b2b.zadosti-odbaveni-grid.dialogDecline.title",
    defaultMessage: "Denial of request"
  },
  filterLabelDateFrom: {
    id: "b2b.zadosti-odbaveni-grid.filter.dateFrom.label",
    defaultMessage: "Date from"
  },
  filterLabelDateTo: {
    id: "b2b.zadosti-odbaveni-grid.filter.dateTo.label",
    defaultMessage: "Date to"
  },
  filterLabelZdroj: {
    id: "b2b.zadosti-odbaveni-grid.filter.zdroj.label",
    defaultMessage: "Resource of request"
  },
  pageHeading: {
    id: "b2b.zadosti-odbaveni-grid.label",
    defaultMessage: "Request processing"
  },
  pageHeadingFilter: {
    id: "b2b.zadosti-odbaveni-grid.action-filter",
    defaultMessage: "Filter"
  },
  toolbarItemAcceptLabel: {
    id: "b2b.zadosti-odbaveni-grid.toolbarItemAccept.label",
    defaultMessage: "CONFIRM"
  },
  toolbarItemDeclineLabel: {
    id: "b2b.zadosti-odbaveni-grid.toolbarItemDecline.label",
    defaultMessage: "DENY"
  }
});

export default () => useMessages(MESSAGES);
